// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { QuickBooksAccount } from './quick-books-account';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JournalEntry extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  created!: Date;
  createdBy?: string;
  creditAccountId!: number;
  debitAccountId!: number;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  docNumber?: string;
  journalEntryDate!: Date;
  notes?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  creditAccount!: QuickBooksAccount;
  debitAccount!: QuickBooksAccount;
}

